import axiosWrapper from '@/utils/request'

const fetchBuyersDetails = (buyerId, params) => {
  return axiosWrapper({
    url: `/v1/business/clients/${buyerId}`,
    params
  })
}
const fetchBuyersBankDetails = (buyerId, params) => {
  return axiosWrapper({
    url: `/v1/business/clients/${buyerId}/view/verified_bank_detail/`,
    params
  })
}
const modifyBuyersDraft = (buyerId, data) => {
  return axiosWrapper({
    method: 'PUT',
    url: `/v1/business/clients/${buyerId}/draft`,
    data,
    timeout: 60000
  })
}
const addBuyers = (data) => {
  return axiosWrapper({
    method: 'POST',
    url: `/v1/business/clients/`,
    data
  })
}
const addBuyerBank = (buyerId, data) => {
  return axiosWrapper({
    method: 'POST',
    url: `/v1/business/clients/${buyerId}/call/create_cover_letter_instruction`,
    data
  })
}

export default {
  fetchBuyersDetails,
  fetchBuyersBankDetails,
  modifyBuyersDraft,
  addBuyers,
  addBuyerBank
}
